import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReportsActions } from '../../components/reports/reports-actions.component';
import PageTitle from 'components/shared/page-title/page-title.component';
import { ReportsProvider } from '../../context/reports-context';

export const Reports: React.FC = () => {
    const { t: translate } = useTranslation(['navigation', 'common']);

    return (
        <ReportsProvider>
            <Box>
                <PageTitle headingStyle="h1" title={translate('navigation:REPORTS')} />
                <ReportsActions />
            </Box>
        </ReportsProvider>
    );
};
